import React from 'react'
import { Route, Redirect } from 'react-router-dom';

var isNewPassword = false;
const OtpVerifiedRoute = ({ component: Component, ...rest }) => {
    const otp = localStorage.getItem('isMailSent');

    if( otp != null) {
        isNewPassword = true;
    }
    
    return (
        <Route {...rest} render={props => (isNewPassword ? <Component {...props} /> : <Redirect to="/" />)} />
    )
}

export default OtpVerifiedRoute